module.exports = __webpack_public_path__ + "static/flags/YM-b1be75c738f07e69fd5461275fa66dfd.gif";